import uuidv4 from 'uuid/v4';
import { logTaggedMessage } from '../reporter';
import React from 'react';
import ReactDOM from 'react-dom';
import { ChallengeModal } from './ChallengeModal';
const log = logTaggedMessage({ module: '3ds' });
function getChallengeIframeContainerElement() {
    return document.getElementById('3ds-challenge');
}
function getChallengeIframeElement(iframeName) {
    return document.getElementById(iframeName);
}
export const createVisibleIframe = (cancelByUserDeferred) => {
    if (getChallengeIframeContainerElement()) {
        log(`WARNING! 3ds: createVisibleIframe: callenge modal iframe already exists`);
        removeChallengeIframe();
    }
    const iframeName = `3ds-iframe-${uuidv4()}`;
    const el = document.createElement('div');
    el.id = '3ds-challenge';
    const onClose = () => {
        log(`3ds: user closed challenge modal (cancelByUserDeferred.reject('CANCELLED_BY_USER'))`);
        return cancelByUserDeferred.reject('CANCELLED_BY_USER');
    };
    ReactDOM.render(React.createElement(ChallengeModal, {
        onClose,
        iframeName,
    }), el);
    document.body.appendChild(el);
    return iframeName;
};
export const removeChallengeIframe = () => {
    const el = getChallengeIframeContainerElement();
    if (!el) {
        log(`WARNING! 3ds: removeChallengeIframe: callenge modal iframe not found on document`);
        return;
    }
    log(`3ds: removeChallengeIframe`);
    document.body.removeChild(el);
};
export const createHiddenIframe = () => {
    const iframe = document.createElement('iframe');
    const iframeName = `3ds-iframe-${uuidv4()}`;
    iframe.name = iframeName;
    iframe.width = '0';
    iframe.height = '0';
    iframe.style.display = 'none';
    iframe.onload = () => log('3ds: hidden iframe loaded', { iframeName });
    document.body.appendChild(iframe);
    return iframeName;
};
export const updateIframeSourceUsingGetRequest = ({ url, iframeName, }) => {
    getChallengeIframeElement(iframeName).src = url;
};
export const postToIframe = ({ url, fields, iframeName, }) => {
    const form = document.createElement('form');
    form.style.display = 'none';
    form.method = 'POST';
    form.target = iframeName;
    form.action = url;
    for (const fieldName of Object.keys(fields)) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = fieldName;
        input.value = fields[fieldName];
        form.appendChild(input);
    }
    document.body.appendChild(form);
    log(`3ds: Posting hidden form into iframe`, {
        url,
        fields,
        iframeName,
    });
    setTimeout(function () {
        try {
            if (document.body.contains(form)) {
                document.body.removeChild(form);
            }
        }
        catch { }
    }, 1000);
    form.submit();
};
//# sourceMappingURL=iframe-handler.js.map